module.exports = __webpack_public_path__ + "static/media/formation0220.07daef65.jpg";